import { render, staticRenderFns } from "./Traingaiqian.vue?vue&type=template&id=77953542&scoped=true"
import script from "./Traingaiqian.vue?vue&type=script&lang=js"
export * from "./Traingaiqian.vue?vue&type=script&lang=js"
import style0 from "./Traingaiqian.vue?vue&type=style&index=0&id=77953542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77953542",
  null
  
)

export default component.exports